import React from 'react';
import { createIcon } from 'components/shared/SVGIcon';

const PinIcon = createIcon(
  'Pin',
  <path d="M17.9,13.2395 C17.9,12.84 17.611,12.517 17.22,12.4065 C16.1405,12.109 15.35,11.123 15.35,9.95 L15.35,5.7 L16.2,5.7 C16.6675,5.7 17.05,5.3175 17.05,4.85 C17.05,4.3825 16.6675,4 16.2,4 L7.7,4 C7.2325,4 6.85,4.3825 6.85,4.85 C6.85,5.3175 7.2325,5.7 7.7,5.7 L8.55,5.7 L8.55,9.95 C8.55,11.123 7.7595,12.109 6.68,12.4065 C6.289,12.517 6,12.84 6,13.2395 L6,13.35 C6,13.8175 6.3825,14.2 6.85,14.2 L11.083,14.2 L11.1,20.15 C11.1,20.6175 11.4825,21 11.95,21 C12.4175,21 12.8,20.6175 12.8,20.15 L12.783,14.2 L17.05,14.2 C17.5175,14.2 17.9,13.8175 17.9,13.35 L17.9,13.2395 Z" />
);

export default PinIcon;
